import { useRouter } from 'next/router';
import { useTranslation } from 'react-i18next';
import { useGetGroup } from 'legacy/groups/hooks';

import PageSkeleton from 'components/PageSkeleton';
import FadeIn from 'legacy/common/components/transition/FadeIn';
import ScreenTopBar, { TopBarVariants } from 'legacy/components/ScreenTopBar';
import TitlesList from './components/TitlesList';
import CenteredContainer from 'components/CenteredContainer';

const OrganizationTitles = () => {
  const { t } = useTranslation(['organizations']);
  const router = useRouter();
  const organizationId = router.query.organizationId as string;
  const { data: organization, isLoading: isLoadingOrganization } = useGetGroup({
    groupId: organizationId
  });

  const goBack = () => {
    router.push(`/organizations/${organization.id}/members`);
  };

  if (isLoadingOrganization || !organization) {
    return <PageSkeleton />;
  }

  return (
    <>
      <ScreenTopBar
        onBack={
          router.pathname !== '/organizations/[organizationId]/dashboard'
            ? goBack
            : undefined
        }
        title={t('titleManagement.manageTitle')}
        variant={TopBarVariants.Big}
        wideContent
      />
      <div className="-mt-[41px] md:mt-[61px] pt-7">
        <FadeIn>
          <CenteredContainer>
            <div className="md:px-20">
              <p className="text-sm text-gray-500">
                {t('titleManagement.mainDescription')}
              </p>

              <TitlesList organizationId={organizationId} />
            </div>
          </CenteredContainer>
        </FadeIn>
      </div>
    </>
  );
};

export default OrganizationTitles;
